// extracted by mini-css-extract-plugin
module.exports = {"read_more":"dece2e673c--read_more--v5dJI","icon":"dece2e673c--icon--BAM3q"};